
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.537 2.457h6.223L9.312 1.073a.607.607 0 01-.196-.444c0-.168.07-.328.196-.445a.68.68 0 01.93 0l2.571 2.457c.06.059.108.127.14.202a.642.642 0 010 .478.6.6 0 01-.14.21l-2.57 2.457a.71.71 0 01-.466.185.692.692 0 01-.465-.185.607.607 0 01-.196-.444c0-.168.07-.328.196-.445l1.448-1.384H4.537c-1.793 0-3.247 1.39-3.247 3.103v1.82c-.01 1.673 1.375 3.05 3.125 3.104h6.933c.363 0 .658.281.658.629 0 .347-.295.629-.658.629h-6.96C1.931 12.923-.016 10.989 0 8.639v-1.82c0-2.4 2.027-4.348 4.537-4.362z","fill":"#fff"}})])
          )
        }
      }
    